import { Action, createReducer, on } from '@ngrx/store';
import { BadResponseWithError } from '@shared/models/common.interface';
import { ReferralsAction } from '../actions/actions-type.action';

export interface ReferralsState {
    referralsRequest: any | null;
    error: BadResponseWithError | null;
    isLoading: boolean;
}

const initialState: ReferralsState = {
    referralsRequest: null,
    error: null,
    isLoading: false,
};

export const reducer = createReducer(
    initialState,
    on(ReferralsAction.fetchReferralsRequests, (state, action) => ({
        ...state,
        isLoading: true,
    })),
    on(ReferralsAction.fetchReferralsRequestsSuccess, (state, action) => {
        return {
            ...state,
            referralsRequest: action.payload.items,
            isLoading: false,
        };
    }),
    on(ReferralsAction.fetchReferralsRequestsFailure, (state, action) => ({
        ...state,
        error: action.payload,
        isLoading: false,
    }))
);
export const referralsReducer = (state: ReferralsState, action: Action) =>
    reducer(state, action);
